document.addEventListener('DOMContentLoaded', function() {
    const hasTocLayout = document.querySelector('.three-column-layout');
    const hasProgressBar = document.querySelector('.progress-container');

    if (!hasTocLayout && !hasProgressBar) {
        return;
    }

    function generateTableOfContents() {
        if (!hasTocLayout) return;

        const articleContent = document.querySelector('.story-box .article-content');
        const tocListContainer = document.querySelector('.article-toc-list');
        if (!articleContent || !tocListContainer) return;

        const headings = articleContent.querySelectorAll('h2, h3');
        if (headings.length < 1) {
            const tocElement = document.querySelector('.post-left-sb');
            if (tocElement) tocElement.style.display = 'none';
            return;
        }

        let currentH2ListItem = null;
        headings.forEach(heading => {
            const level = heading.tagName.toLowerCase();
            const title = heading.textContent.trim();
            if (!title) return;

            const id = title.toLowerCase().replace(/[^a-z0-9\s-]/g, '').trim().replace(/\s+/g, '-');
            heading.id = id;

            // ===================================================
            // START: 已添加的代码
            // 为每个h2和h3标题添加'anchor-target' class
            heading.classList.add('anchor-target');
            // END: 已添加的代码
            // ===================================================

            const listItem = document.createElement('li');
            listItem.className = `toc-level-${level}`;
            const link = document.createElement('a');
            link.href = `#${id}`;
            link.textContent = title;
            listItem.appendChild(link);

            if (level === 'h2') {
                tocListContainer.appendChild(listItem);
                currentH2ListItem = listItem;
            } else if (level === 'h3' && currentH2ListItem) {
                let sublist = currentH2ListItem.querySelector('ul');
                if (!sublist) {
                    sublist = document.createElement('ul');
                    currentH2ListItem.appendChild(sublist);
                }
                sublist.appendChild(listItem);
            }
        });
    }

    function handleScrollProgressBar() {
        const progressBarContainer = document.querySelector('.progress-container');
        const desktopHeader = document.querySelector('.shopify-section-header-sticky');
        const mobileHeader = document.querySelector('.section-header-mobile');
        const contentWrapper = document.querySelector('.halo-article-block, .story-box');

        if (!progressBarContainer || !contentWrapper || (!desktopHeader && !mobileHeader)) {
            if (progressBarContainer) progressBarContainer.style.display = 'none';
            return;
        }

        const progressBar = progressBarContainer.querySelector('.progress-bar');
        if (!progressBar) return;

        const progressBarOffsetTop = progressBarContainer.offsetTop;

        function updateScroll() {
            let activeStickyHeader = null;
            if (window.innerWidth <= 1024 && mobileHeader) {
                activeStickyHeader = mobileHeader;
            } else {
                activeStickyHeader = desktopHeader;
            }
            
            if (!activeStickyHeader) return;

            const stickyHeaderHeight = activeStickyHeader.offsetHeight;
            
            if (window.scrollY >= (progressBarOffsetTop - stickyHeaderHeight)) {
                if (!progressBarContainer.classList.contains('sticky')) {
                    progressBarContainer.classList.add('sticky');
                    progressBarContainer.style.setProperty('top', stickyHeaderHeight + 'px', 'important');
                }
            } else {
                if (progressBarContainer.classList.contains('sticky')) {
                    progressBarContainer.classList.remove('sticky');
                    progressBarContainer.style.removeProperty('top'); 
                }
            }
            
            const scrollableHeight = contentWrapper.scrollHeight - window.innerHeight;
            const contentRect = contentWrapper.getBoundingClientRect();
            const scrolledDistance = -contentRect.top;
            let progress = 0;
            if (scrollableHeight > 0) {
                const adjustedScrolledDistance = Math.max(0, scrolledDistance);
                progress = (adjustedScrolledDistance / scrollableHeight) * 100;
            }
            
            progress = Math.min(Math.max(progress, 0), 100);
            progressBar.style.width = progress + '%';
        }
        
        updateScroll();
        window.addEventListener('scroll', updateScroll, { passive: true });
        window.addEventListener('resize', updateScroll);
    }

    function handleMobileTocToggle() {
        if (!hasTocLayout) return;

        const tocTitle = document.querySelector('.toc-title');
        const tocList = document.querySelector('.article-toc-list');
        if (tocTitle && tocList) {
            tocTitle.addEventListener('click', () => {
                if (window.innerWidth <= 1024) {
                    tocTitle.classList.toggle('expanded');
                    tocList.classList.toggle('expanded');
                }
            });
        }
    }

    generateTableOfContents();
    handleScrollProgressBar();
    handleMobileTocToggle();
});


/**
 * ===================================================================================
 * START: SLICK SLIDER FIX (FINAL VERSION 2.0)
 * This version handles both initial load and subsequent slide changes.
 * ===================================================================================
 */
window.addEventListener('load', function() {
    // Target any slider with the unique 'data-product-slider-sidebar' attribute.
    const sidebarSliders = $('[data-product-slider-sidebar]');

    if (sidebarSliders.length > 0) {
        // 1. Fix the initial position for all sliders at once on page load.
        sidebarSliders.slick('setPosition');

        // 2. NEW: Bind the 'afterChange' event handler to all found sliders.
        // This event fires after a slide changes.
        sidebarSliders.on('afterChange', function(event, slick, currentSlide) {
            // 'this' refers to the specific slider that triggered the event.
            // We run setPosition again on that specific slider to correct its layout,
            // which fixes issues caused by lazy-loaded images in the new slide.
            $(this).slick('setPosition');
        });
    }
});